import { css } from 'aphrodite';
import * as React from 'react';
import { getDefaultDateStringValue, getDefaultTimeStringValue } from '../../../../models/UiUtils';
import { isSocialSendNow } from './resourceHelpers';
import { s } from './styles';
import { IAIScheduleSuccessProps } from './types';

interface SuccessMessageProps {
	props: IAIScheduleSuccessProps;
	primaryResourceType?: string;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({ props, primaryResourceType }) => {
	const { resourceType, estimate, socialPost, multiple } = props;
	const displayResourceType = primaryResourceType || resourceType;

	// Only use resource-specific data if it matches the displayed resource type
	const relevantEstimate = displayResourceType === 'email' && resourceType === 'email' ? estimate : null;
	const relevantSocialPost = displayResourceType === 'social' && resourceType === 'social' ? socialPost : null;
	const sendNow = isSocialSendNow(relevantSocialPost);

	const renderMessage = (): React.ReactNode => {
		switch (displayResourceType) {
			case 'email':
				if (relevantEstimate) {
					return (
						<div className={css(s.titleMessage)}>
							{`Your emails will start to send on ${getDefaultDateStringValue(
								relevantEstimate.estimate.startDate
							)} at ${getDefaultTimeStringValue(relevantEstimate.estimate.startDate)}.`}
						</div>
					);
				}
				return null;

			case 'social': {
				if (!relevantSocialPost) {
					return null;
				}
				return (
					<div className={css(s.titleMessage)}>
						{sendNow ? (
							<span>Your post will be delivered in the next 5 minutes.</span>
						) : (
							<span>
								Your post will be delivered on {getDefaultDateStringValue(relevantSocialPost.dueMoment)} at
								{getDefaultTimeStringValue(relevantSocialPost.dueMoment)}.
							</span>
						)}
					</div>
				);
			}

			case 'blog':
				return (
					<div className={css(s.titleMessage)}>
						<h1>{`Your ${multiple ? 'Blogs have' : 'Blog has'} been scheduled`}</h1>
					</div>
				);

			default:
				return null;
		}
	};

	return <>{renderMessage()}</>;
};
